import { CommonModule } from '@angular/common';
import { booleanAttribute, ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { MatRadioButton } from '@angular/material/radio';

@Component({
  selector: 'csl-mat-radio',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './radio.component.html',
  styleUrl: './radio.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioComponent extends MatRadioButton {
  @Input({ transform: booleanAttribute }) public isHidden = false;
  @Input({ transform: booleanAttribute }) public sharpCorners = false;

  @HostBinding('class.sharp-corners') get isSharpCorners() {
    return this.sharpCorners;
  }
}
